import { ElMessage } from 'element-plus';

/**
 * message消息提示
 * @param msg 提示语
 * @param type 提示类型
 */
export const messageTip = (msg: string, type: 'success' | 'warning' | 'info' | 'error' = 'success') => {
    ElMessage({
      message: msg,
      type: type,
      duration: 2000,
      zIndex: 9999,
      offset: 100,
    })
}

// Vite 动态引入本地图片方法
export const getImageUrl = (name: string) => {
  return new URL(`../assets/imgs/${name}`, import.meta.url).href
}

// 去除html标签
export const stripHtml = (html?: string) => {
  if (!html) return ''
  const withImagePlaceholder = html.replace(/<img[^>]*>/gi, '[图片]')
  return withImagePlaceholder.replace(/<[^>]+>/g, '')
}

// 生成摘要
export const makeExcerpt = (html?: string) => {
  const text = stripHtml(html)
  const hasImage = text.includes('[图片]')
  const cleaned = text.replace(/\[图片\]/g, '')
  const base = cleaned.trim()
  const truncated = base.length > 120 ? `${base.slice(0, 120)}…` : base
  return hasImage ? `${truncated} [图]` : truncated
}

// 格式化数字，每三位加逗号
export const formatNumberWithThreeDigits = (num: any) => {
  // 先将数字转换为字符串，然后使用正则表达式进行格式化
  // return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return num.toString();
}

// 格式化时间戳
export const formatTimestamp = (type: 'date' | 'time' | 'datetime' = 'datetime') => {
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  if (type === 'date') {
    return `${year}-${month}-${day}`;
  }
  if (type === 'time') {
    return `${hours}:${minutes}:${seconds}`;
  }
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

// 更新浏览量（无token版，调用新公开接口）
export const updateViews = async (filename: string, currentId: number | string) => {
  try {
    const res = await fetch('/w-api/data/public/update-views', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        filename,  // 例如: "news.json"
        id: currentId
      })
    })

    if (res.ok) {
      console.log('✅ 浏览量更新成功')
    } else {
      console.error('❌ 浏览量更新失败')
    }
  } catch (err) {
    console.error('⚠️ 网络异常，更新失败', err)
  }
}